import React from 'react';
import PropTypes from 'prop-types';
import CommonSpecialRow from './CommonSpecialRow';
import DelimiterRow from './DelimiterRow';

const SpecialRow = ({ isSpecial, daysBreak, ...props }) => isSpecial && (
    daysBreak ?
        <DelimiterRow daysBreak={daysBreak} {...props} /> :
        <CommonSpecialRow {...props} />
);

SpecialRow.propTypes = {
    isSpecial: PropTypes.bool,
    daysBreak: PropTypes.number,
};

export default SpecialRow;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/SpecialRow.jsx